<template>
    <Upload
        :show-upload-list="false"
        :action="uploadFileUrl"
        :headers="headers"
        :disabled="itemDisabled"
        :before-upload="beforeUpload"
        :accept="format.map((m) => `.${m}`).join(',')"
        :format="format"
        :on-success="onSuccess"
        :on-error="onError"
        :on-exceeded-size="onExceededSize"
        :max-size="maxSize"
        class="my-upload"
        :style="{ cursor: itemDisabled ? 'default' : 'pointer' }"
    >
        <div v-if="!value" style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #39f"></Icon>
            <p>点击上传图片</p>
        </div>
        <div v-else>
            <Poptip trigger="hover" placement="right">
                <img :src="baseUrl + value" class="preview-img" alt="" />
                <img
                    v-if="!!value"
                    slot="content"
                    :src="baseUrl + value"
                    height="350"
                    alt=""
                />
            </Poptip>

            <!-- <div @click="download" class="notice">点击下载图片</div> -->
            <div v-if="!itemDisabled" class="del" @click="delImg($event)">
                <Icon type="ios-trash-outline" />
            </div>
        </div>
    </Upload>
</template>

<script>
import { getLocal, getImage } from '@/utils/func';
import API, { prefixUrl } from '@/api';
// import { getOcrInfo } from '@/api/base';

export default {
    name: 'UploadImage',
    inject: {
        FormInstance: {
            default: '',
        },
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        useOcr: {
            type: Boolean,
            default: false,
        },
        ocrType: {
            type: String,
            default: '04',
        },
        maxSize: { type: Number, default: 10240 },
    },
    data() {
        return {
            uploadFileUrl: API.server + 'core/attach/upload',
            baseUrl: API.server + 'core' + prefixUrl,
            headers: {
                Authorization: getLocal('token'),
                applicationCode: '1000',
                PlatformId: 'SF',
            },
            format: ['jpg', 'jpeg', 'png', 'webp'],
            uploadLoading: false,
        };
    },
    computed: {
        imgUrl: {
            set(val) {
                this.$emit('input', val);
            },
            get() {
                return this.value;
            },
        },
        itemDisabled() {
            let state = this.disabled;
            if (!state && this.FormInstance) state = this.FormInstance.disabled;
            return state;
        },
    },
    methods: {
        onExceededSize(file) {
            this.$Modal.error({
                title: `图片(${file.name})上传失败`,
                content: '文件限制为10M',
            });
        },
        download() {
            window.open(this.baseUrl + this.value);
        },
        /**
         * 上传拦截，用于其他类型上传用途
         * @param {File} file
         * @return {boolean}
         */
        beforeUpload(file) {
            if (!this.useOcr) return true;
            // getImage(
            //     file,
            //     async (formData) => {
            //         const res = await getOcrInfo(formData);
            //         if (res.success) {
            //             this.$emit('getOcrInfo', res.data);
            //         } else {
            //             this.onError(res, file);
            //         }
            //     },
            //     this.ocrType
            // );
            return true;
        },
        onSuccess(res, file) {
            if (res.success) {
                this.$Message.success(`图片(${file.name})上传成功`);
                this.imgUrl = res.data.attachPath;
            } else {
                this.onError(res, file);
            }
        },
        onError(res, file) {
            this.$Modal.error({
                title: `图片(${file.name})上传失败`,
                content: `错误信息: ${res.message}`,
            });
        },
        delImg(e) {
            e.stopPropagation();
            this.$Modal.confirm({
                title: '确定要删除当前上传的图片吗?',
                onOk: () => {
                    this.imgUrl = null;
                },
            });
        },
    },
};
</script>

<style scoped>
/* 上传图片 */
.my-upload {
    width: 100%;
    text-align: center;
    cursor: pointer;
    border: 1px dashed #ccc;
}
.my-upload >>> .ivu-upload {
    width: 100%;
}

.preview-box {
    position: relative;
}
.preview-box .notice {
    position: absolute;
    width: 100%;
    height: 30px;
    background-color: rgba(255, 255, 255, 0.4);
    text-align: center;
    color: #333;
    display: none;
    bottom: 0;
    left: 0;
}
.preview-box .del {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #f00;
    display: none;
    background-color: rgba(255, 255, 255, 0.4);
    font-size: 20px;
}
.preview-box:hover .del,
.preview-box:hover .notice {
    display: block;
}
.preview-img {
    max-width: 100%;
    max-height: 114px;
}
</style>
